import { useQuery } from "@tanstack/react-query";
import autoAssignService from "../../../../services/web/auto-assign-service";

function mapResponse(d) {
    d = d ?? {};

    return {
        id: d.id ?? null,
        plate: d.plate ?? "",
        reason: d.reason ?? "",
        expiresAt: d.expiresAt ?? null,
        userName: d.userName ?? "",
        createdAt: d.createdAt ?? null,
        updatedByUserName: d.updatedByUserName ?? "",
        updatedOn: d.updatedOn ?? null,
        expired: d.expired ?? false,
        };
}

export function useAutoAssignFormQuery(id) {
    return useQuery({
        queryKey: ["autoAssignForm", id],
        enabled: !!id,
        queryFn: async () => {
            const data = await autoAssignService.getById(id);
            return mapResponse(data);
        },
    });
}